import Navigation from "@/components/landing/Navigation";
import ConnectedCareHero from "@/components/landing/ConnectedCareHero";
import Hero from "@/components/landing/Hero";
import TrustedBy from "@/components/landing/TrustedBy";
import ProcessFlow from "@/components/landing/ProcessFlow";
import CollaboratorsCarousel from "@/components/landing/CollaboratorsCarousel";
import Footer from "@/components/landing/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-neutral-100 to-neutral-50 relative overflow-hidden">
      {/* Flowing background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-[60%] bg-gradient-to-bl from-secondary/15 via-secondary/8 to-transparent blur-3xl" />
      <div className="absolute top-1/4 left-0 w-1/3 h-[50%] bg-gradient-to-r from-accent-teal/12 via-accent-teal/6 to-transparent blur-2xl" />
      <div className="absolute bottom-0 right-1/4 w-1/2 h-[40%] bg-gradient-to-t from-secondary/10 via-transparent to-transparent blur-3xl" />
      
      <div className="relative z-10">
        <Navigation />
      <ConnectedCareHero />
      <Hero />
      <TrustedBy />
      <CollaboratorsCarousel />
      <Footer />
      </div>
    </div>
  );
};

export default Index;